import { useCallback } from "react";
import { TrackingClient } from "@sparefoot/tracking-client";

const useFormTracking = ({ onSubmit, id }) => {
	const handleSubmit = useCallback(
		async (data, event) => {
			if (event) {
				event.stopPropagation();
				event.preventDefault();
			}

			const form = event?.target;
			const trackingData = {
				form_id: form?.id || id || form?.className || "",
				form_target: form?.action,
				form_url: form?.baseURI,
				email: data.email || undefined,
				first_name:
					data.firstName || data.alternateFirstNames || undefined,
				last_name: data.lastName || data.alternateLastNames || undefined
			};

			TrackingClient.trackFormSubmitted(trackingData);

			return Promise.resolve(onSubmit(data, event));
		},
		[onSubmit, id]
	);

	return { handleSubmit };
};

export default useFormTracking;
